import { useTranslation } from 'next-i18next';

import SectionSummary from '@components/molecules/cpdEnrollment/confirmAllInformation/sectionSummary';
import { CPDEnrollmentForm, LicenseType } from 'src/helpers/constants';
import { getCpdLicenseTitleKey, removeSpaceFromText, getLicenseTypeName, toCapitalized } from 'src/helpers/utils';
import {
  CPDRegulatorTypeEnum,
  ICPDCourse,
  LicenseRenewalTypeEnum,
  CPDLicenseTypeEnum,
  ApplicantTypeEnum,
} from 'src/interfaces';

type LicenseSummaryProps = {
  cpdEnrollmentForm: {
    [x: string]: any;
  };
  haveOicFourthPlus: boolean;
};

const CPDBundleLicenseSummary = ({ cpdEnrollmentForm, haveOicFourthPlus }: LicenseSummaryProps) => {
  const { t } = useTranslation();

  const renderOICLicenses = () => {
    const applicantTypes = [ApplicantTypeEnum.BROKER, ApplicantTypeEnum.AGENT];
    const oicLicenseTypes = [CPDLicenseTypeEnum.LIFE, CPDLicenseTypeEnum.NON_LIFE];

    const sectionsSummary = [];

    for (const applicantType of applicantTypes) {
      const applicantTypeName = toCapitalized(applicantType);
      for (const oicLicenseType of oicLicenseTypes) {
        const licenseTypeName = getLicenseTypeName(oicLicenseType);

        const licenseNo = cpdEnrollmentForm[`oic${applicantTypeName}${licenseTypeName}LicenseNo`];
        const licenseStartDate = cpdEnrollmentForm[`oic${applicantTypeName}${licenseTypeName}StartDate`];
        const licensEndDate = cpdEnrollmentForm[`oic${applicantTypeName}${licenseTypeName}EndDate`];
        const isSelectLicense = cpdEnrollmentForm[`isSelect${applicantTypeName}OIC${licenseTypeName}License`];

        if (!licenseNo || (haveOicFourthPlus && !isSelectLicense)) continue;

        sectionsSummary.push(
          <SectionSummary
            title={t(
              getCpdLicenseTitleKey(
                CPDRegulatorTypeEnum.OIC,
                LicenseRenewalTypeEnum.NotSet,
                applicantType,
                oicLicenseType,
              ),
            )}
            items={{
              [t('cpd_enrollment.license_information.number')]: licenseNo as string,
              [t('cpd_enrollment.license_information.start_date')]: removeSpaceFromText(licenseStartDate as string),
              [t('cpd_enrollment.license_information.end_date')]: removeSpaceFromText(licensEndDate as string),
            }}
          />,
        );
      }
    }

    return <>{sectionsSummary}</>;
  };

  const renderTSILicenses = () => {
    if (!cpdEnrollmentForm.tsiLicenseNo) return <></>;

    return (
      <SectionSummary
        title={t(
          getCpdLicenseTitleKey(
            CPDRegulatorTypeEnum.OIC,
            LicenseRenewalTypeEnum.NotSet,
            ApplicantTypeEnum.ADVISOR,
            CPDLicenseTypeEnum.INVESTMENT,
          ),
        )}
        items={{
          [t('cpd_enrollment.license_information.type')]: cpdEnrollmentForm.tsiLicenseName as string,
          [t('cpd_enrollment.license_information.number')]: cpdEnrollmentForm.tsiLicenseNo as string,
          [t('cpd_enrollment.license_information.start_date')]: removeSpaceFromText(
            cpdEnrollmentForm.tsiStartDate as string,
          ),
          [t('cpd_enrollment.license_information.end_date')]: removeSpaceFromText(
            cpdEnrollmentForm.tsiEndDate as string,
          ),
        }}
      />
    );
  };

  return (
    <>
      {renderOICLicenses()} {renderTSILicenses()}
    </>
  );
};

export default CPDBundleLicenseSummary;
